export enum UserStatus {
	Active = 'Active',
	Inactive = 'Inactive',
	RegistrationRequestSent = 'RegistrationRequestSent',
}
